import { Phone, MapPin, Clock, MessageCircle } from "lucide-react";
import { BUSINESS } from "@/lib/config";

export default function Contact() {
  const mapSrc = `https://www.google.com/maps?q=${encodeURIComponent(BUSINESS.mapQuery)}&output=embed`;

  return (
    <section id="contact" className="py-20 lg:py-32 bg-zinc-50" data-testid="contact-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-12 gap-10 lg:gap-16 mb-12">
          <div className="lg:col-span-5">
            <div className="text-xs font-bold uppercase tracking-[0.2em] text-[#1D4ED8] mb-4">
              / İletişim
            </div>
            <h2 className="text-3xl sm:text-4xl lg:text-5xl font-black tracking-tighter text-zinc-950 leading-[1.05]" data-testid="contact-title">
              Bize ulaşın, <br />
              <span className="text-[#FF4500]">aynı gün</span> gelelim.
            </h2>
            <p className="mt-6 text-zinc-600 text-base leading-relaxed">
              Acil arıza için telefon en hızlı yol. Ziyaret etmek isterseniz dükkanımız
              Peyas Mahallesi'nde hizmetinizde.
            </p>
          </div>

          <div className="lg:col-span-7 grid sm:grid-cols-2 gap-4">
            <a href={`tel:${BUSINESS.phone1Tel}`} className="group p-6 bg-white border border-zinc-200 rounded-sm hover:border-[#FF4500] transition-colors" data-testid="contact-phone1-card">
              <Phone className="w-5 h-5 text-[#FF4500] mb-3" />
              <div className="text-xs uppercase tracking-widest text-zinc-500 font-bold mb-1">Telefon 1</div>
              <div className="text-2xl font-black text-zinc-950 group-hover:text-[#FF4500]">{BUSINESS.phone1}</div>
            </a>
            <a href={`tel:${BUSINESS.phone2Tel}`} className="group p-6 bg-white border border-zinc-200 rounded-sm hover:border-[#FF4500] transition-colors" data-testid="contact-phone2-card">
              <Phone className="w-5 h-5 text-[#FF4500] mb-3" />
              <div className="text-xs uppercase tracking-widest text-zinc-500 font-bold mb-1">Telefon 2</div>
              <div className="text-2xl font-black text-zinc-950 group-hover:text-[#FF4500]">{BUSINESS.phone2}</div>
            </a>
            <a
              href={`https://wa.me/${BUSINESS.whatsapp.replace("+", "")}`}
              target="_blank"
              rel="noopener noreferrer"
              className="p-6 bg-emerald-600 text-white rounded-sm hover:bg-emerald-700 transition-colors"
              data-testid="contact-whatsapp-card"
            >
              <MessageCircle className="w-5 h-5 mb-3" />
              <div className="text-xs uppercase tracking-widest font-bold mb-1 opacity-80">WhatsApp</div>
              <div className="text-xl font-black">Mesaj Gönder</div>
            </a>
            <div className="p-6 bg-white border border-zinc-200 rounded-sm">
              <Clock className="w-5 h-5 text-[#FF4500] mb-3" />
              <div className="text-xs uppercase tracking-widest text-zinc-500 font-bold mb-1">Çalışma Saatleri</div>
              <div className="text-base font-bold text-zinc-950">7/24 Açık</div>
              <div className="text-xs text-zinc-500 mt-1">Acil servis her zaman aktif</div>
            </div>
          </div>
        </div>

        <div className="grid lg:grid-cols-12 gap-6 mt-6">
          <div className="lg:col-span-5 p-6 bg-white border border-zinc-200 rounded-sm" data-testid="address-card">
            <MapPin className="w-5 h-5 text-[#FF4500] mb-3" />
            <div className="text-xs uppercase tracking-widest text-zinc-500 font-bold mb-2">Adres</div>
            <div className="text-base text-zinc-900 leading-relaxed font-medium">
              {BUSINESS.address}
            </div>
            <a
              href={`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(BUSINESS.mapQuery)}`}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-block mt-4 text-sm font-bold text-[#FF4500] border-b border-[#FF4500] pb-0.5"
              data-testid="open-maps-link"
            >
              Haritada Aç →
            </a>
          </div>
          <div className="lg:col-span-7 aspect-video lg:aspect-auto min-h-[300px] border border-zinc-200 rounded-sm overflow-hidden" data-testid="map-container">
            <iframe
              title="Akın Kombi konum"
              src={mapSrc}
              width="100%"
              height="100%"
              style={{ border: 0, minHeight: "300px" }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            />
          </div>
        </div>
      </div>
    </section>
  );
}
